import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const WorkplaceManagementTrainingPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Workplace Mgmt & Training | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Workplace Mgmt & Training overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Workplace Mgmt & Training</h1>
        <p>Welcome to the workplace-management-training page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default WorkplaceManagementTrainingPage
